import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { Button } from "./Common";

const AddContactButton = styled(Button)`
  border: none;
  font-family: ${({ theme }) => theme.fontFamily.REGULAR};
  font-family: ${({ theme }) => theme.palette.SECONDARY};
  margin-right: 15px;
  padding: 8px 20px 8px 15px;
  align-self: center;
  display: inline-block;
`;

const PopUp = ({
  text,
  rightBtnText,
  leftBtnText,
  onSubmit,
  onCancel,
  className,
  open
}) => {
  return (
    <div className={className}>
      <Dialog
        open={open}
        onClose={onCancel}
        fullWidth
        maxWidth="sm"
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <DialogContentText>{text}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <AddContactButton className="button" onClick={onCancel}>
            {rightBtnText}
          </AddContactButton>
          <AddContactButton onClick={onSubmit} color="primary" autoFocus>
            {leftBtnText}
          </AddContactButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

PopUp.propTypes = {
  text: PropTypes.string,
  rightBtnText: PropTypes.string,
  leftBtnText: PropTypes.string,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  className: PropTypes.string,
  open: PropTypes.bool
};

PopUp.defaultProps = {
  text: "",
  rightBtnText: "",
  leftBtnText: "",
  onSubmit: () => {},
  onCancel: () => {},
  className: "",
  open: false
};

export const PopUpModel = PopUp;
